module.exports = __webpack_public_path__ + "img/nav.41ed34c8.png";